// LÓGICA DE ABERTURA E FECHAMENTO DO MODAL NUTRICIONAL (DESKTOP)
;(function () {
    var buttons = document.querySelectorAll('[data-open-nutricional]')

    buttons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault()
            var variantId = btn.getAttribute('data-open-nutricional')
            var modal = document.getElementById(
                'pdp-nutricional-' + variantId,
            )

            if (modal) {
                modal.classList.add('open')
                modal.setAttribute('aria-hidden', 'false')
                document.body.style.overflow = 'hidden'

                var closeBtn = modal.querySelector(
                    '.pdp-nutricional-modal__close',
                )

                function closeModal() {
                    modal.classList.remove('open')
                    modal.setAttribute('aria-hidden', 'true')
                    document.body.style.overflow = ''

                    if (closeBtn)
                        closeBtn.removeEventListener('click', closeModal)
                    modal.removeEventListener('click', handleOutsideClick)
                }

                function handleOutsideClick(event) {
                    if (
                        event.target === modal ||
                        event.target.classList.contains(
                            'pdp-nutricional-modal__overlay',
                        )
                    ) {
                        closeModal()
                    }
                }

                if (closeBtn) closeBtn.addEventListener('click', closeModal)
                modal.addEventListener('click', handleOutsideClick)
            }
        })
    })
})()
